import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import * as fromGenerated from '../../../../../_generated';
import { SpeechToTextApiKeyServiceInterface } from '../prompt-input-speech-to-text.interfaces';

@Injectable()
export class SpeechToTextAzureApiKeyService implements SpeechToTextApiKeyServiceInterface {
  private readonly azureService =
    inject<fromGenerated.SpeechToTextAzureService>(
      fromGenerated.SpeechToTextAzureService,
    );

  async getApiKey(): Promise<string> {
    try {
      const newApiKey = await firstValueFrom(
        this.azureService.azureControllerGenerateApiKeyV1(),
      );

      // For Azure, this is not an API key we're returning but an authentication token. An authentication token is
      // valid for 10 minutes.
      // See https://learn.microsoft.com/en-us/azure/ai-services/authentication#authenticate-with-an-access-token
      return newApiKey.key;
    } catch (error) {
      console.error('Failed to generate Azure API key', error);
      throw error;
    }
  }
}
